import {FormParagraphConfigurationModel} from './form-paragraph-configuration.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';
import {XauditModel} from '../xaudit.model';

export class FormVersionConfigurationModel extends XauditModel {
    DFormVersionId: string;
    DFormId: string;
    Version: number;
    Revision: number;
    enumDFormBuildStatusID: string;
    DFormBuildStatusBy: string;
    DFormBuildStatusOn: Date;
    cfgDFormParagraphs: FormParagraphConfigurationModel[];
    enumDFormBuildStatus: EnumValidValueItemModel;
}
